import { useState } from "react"
import { getBacklinks } from "../../api/api"
import { compactNumber } from "../../utils/seo"

export default function Backlinks() {
  const [domain, setDomain] = useState("")
  const [data, setData] = useState(null)
  const [error, setError] = useState("")

  async function load() {
    setError("")
    try {
      const res = await getBacklinks(domain)
      setData(res.data)
    } catch (err) {
      setError(err.response?.data?.error || "Failed to load backlink data")
    }
  }

  const linkAnalytics = data?.linkAnalytics || {}
  const weakPages = data?.weakPages || []

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Backlink Analytics</h1>
          <p className="muted">Authority, referring-domain and internal-link intelligence from the latest report.</p>
        </div>
      </div>

      <div className="card form-row">
        <label>
          Domain
          <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="example.com" />
        </label>
        <button onClick={load}>Load backlinks</button>
      </div>

      {error && <p className="error">{error}</p>}

      {data && (
        <>
          <div className="grid">
            <div className="metric-card">
              <p className="metric-label">Authority score</p>
              <div className="metric">{linkAnalytics.authorityScore || 0}</div>
              <p className="muted">Proxy score from links and page quality</p>
            </div>
            <div className="metric-card">
              <p className="metric-label">Backlinks</p>
              <div className="metric">{compactNumber(data.totalBacklinks || linkAnalytics.backlinkCount || 0)}</div>
              <p className="muted">Saved link signals</p>
            </div>
            <div className="metric-card">
              <p className="metric-label">Referring domains</p>
              <div className="metric">{compactNumber(data.referringDomains || linkAnalytics.referringDomains || 0)}</div>
              <p className="muted">Unique discovered source domains</p>
            </div>
            <div className="metric-card">
              <p className="metric-label">Avg internal links</p>
              <div className="metric">{linkAnalytics.averageInternalLinks || 0}</div>
              <p className="muted">Per crawled page</p>
            </div>
          </div>

          <div className="split-grid pro-section">
            <div className="card">
              <h2>Top Domains</h2>
              <div className="table-wrap">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Domain</th>
                      <th>Links</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(data.topDomains || []).map((item) => (
                      <tr key={item.domain}>
                        <td><strong>{item.domain}</strong></td>
                        <td>{item.count}</td>
                      </tr>
                    ))}
                    {!(data.topDomains || []).length && (
                      <tr>
                        <td colSpan="2" className="muted">No backlink domains yet.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card">
              <h2>Internal Link Fixes</h2>
              <div className="insight-list">
                {weakPages.map((page) => (
                  <div className="insight-item" key={page.url}>
                    <strong>{page.title}</strong>
                    <p className="muted">{page.url}</p>
                    <p>{page.internalLinks} internal links. Add contextual links from relevant pages.</p>
                  </div>
                ))}
                {weakPages.length === 0 && <div className="empty-state">No weak internal-link pages detected.</div>}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
